/* eslint-disable import/no-cycle */
/* eslint-disable no-param-reassign */
/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */

import { set } from 'lodash-es';
import { sendClaimEmail } from '@/services/api/buy/subscription';
import {
  findAllClaimsByCompanyId,
  findClaimDocumentsById,
  addDocumentsToClaimById,
} from '@/services/api/customer/claims';

// initial state
const state = {
  claims: [],
  reference: { code: null },
  productId: null,
  claimDate: '',
  type: '',
  context: '',
  attachments: [],
};
// getters
const getters = {
  currentProductId: (state) => state.productId,
  currentReference: (state) => state.reference,
  type: (state) => state.type,
  reference: (state) => state.reference,
  claimDate: (state) => state.claimDate,
  context: (state) => state.context,
  claims: (state) => state.claims,
};

function resolveClaimPolicyId(claim = {}) {
  const contract = claim.subscription || claim.policy || {};
  return claim.policyId || contract.policyId || contract.id || null;
}

function buildClaimDocumentPayload(claim, companyId) {
  const policyId = resolveClaimPolicyId(claim);
  return {
    policyId,
    companyId,
    policy: { id: policyId },
    subscription: { id: policyId },
  };
}

// actions
const actions = {
  async addDocumentsToClaim({ rootGetters }, shadowClaim) {
    // Get company ID
    const companyId = rootGetters['company/companyId'];
    // Build claim payload
    const claim = buildClaimDocumentPayload(shadowClaim, companyId);
    // Append to formData
    try {
      const formData = new FormData();
      state.attachments
        .forEach((attachmentArray) => {
          attachmentArray.forEach((element) => {
            if (element) {
              formData.append('attachments', element, element.name);
            }
          });
        });
      const json = new Blob([JSON.stringify(claim)], { type: 'application/json' });
      formData.append('claim', json);
      // Send post request
      return addDocumentsToClaimById(shadowClaim.id, formData);
    } catch (err) {
      return Promise.reject(err);
    }
  },
  async sendEmail({ rootGetters, state }) {
    // Get contract ID
    const subscriptions = rootGetters['contracts/get'];
    const companyId = rootGetters['company/companyId'];
    const subscription = (subscriptions
      .find(({ reference }) => state.reference.code === reference))
      || {};
    console.log('subscription', subscription);

    // Build claim
    const claim = {
      companyId,
      context: state.context,
      claimDate: state.claimDate,
      policyId: subscription.policyId,
      type: state.type.code,
    };

    // Append to formData
    try {
      const formData = new FormData();
      state.attachments
        .forEach((attachmentArray) => {
          attachmentArray.forEach((element) => {
            if (element) {
              formData.append('attachments', element, element.name);
            }
          });
        });
      const json = new Blob([JSON.stringify(claim)], { type: 'application/json' });
      formData.append('claim', json);

      // Send post request
      return sendClaimEmail(formData, subscription.policyId);
    } catch (err) {
      return Promise.reject(err);
    }
  },
  async getClaims({ commit, rootGetters }) {
    const companyId = rootGetters['company/get'].id;
    const { data: claims } = await findAllClaimsByCompanyId(companyId);
    commit('setValue', { claims });
  },
  async getClaimDocuments(unused, claimId) {
    const { data: documents } = await findClaimDocumentsById(claimId);
    return documents;
  },
  clear({ commit }) {
    commit('CLEAR');
  },
  deleteAttachments({ commit }, index) {
    commit('DELETE_ATTACHMENTS', index);
  },
  setAttachments({ commit }, { index, attachments }) {
    commit('SET_ATTACHMENTS', { index, attachments });
  },
  setValue({ commit }, object) {
    commit('setValue', object);
  },
  setValueWithPath({ commit }, object) {
    commit('setValueWithPath', object);
  },
};

// mutations
const mutations = {
  CLEAR(state) {
    state.productId = null;
    state.reference = { code: null };
    state.claimDate = '';
    state.type = '';
    state.context = '';
    state.attachments = [];
    state.fileUploaded = false;
  },
  setValue(state, object) {
    const [key] = Object.keys(object);
    state[key] = object[key];
  },
  setValueWithPath(state, { value, path }) {
    set(state, path, value);
  },
  DELETE_ATTACHMENTS(state, index) {
    state.attachments[index] = [];
  },
  SET_ATTACHMENTS(state, { index, attachments }) {
    state.attachments[index] = [];
    Array.from(attachments).forEach((file) => {
      state.attachments[index].push(file);
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export {
  buildClaimDocumentPayload,
  resolveClaimPolicyId,
};
